import { ShieldCheck, Sparkles, Clock, GitBranch } from "lucide-react";
import Reveal from "@/components/Reveal";

const features = [
  {
    icon: ShieldCheck,
    title: "Siguranță",
    text: "Vehicule întreținute la cele mai înalte standarde și șoferi cu zeci de mii de km experiență.",
  },
  {
    icon: Sparkles,
    title: "Confort",
    text: "Flotă modernă, climatizată, dotată pentru călătorii relaxante alături de familie sau prieteni.",
  },
  {
    icon: Clock,
    title: "Punctualitate",
    text: "Respectăm fiecare minut din programul tău. Plecări la timp, garantat.",
  },
  {
    icon: GitBranch,
    title: "Flexibilitate",
    text: "Rute personalizate la cerere — adaptăm totul nevoilor tale specifice.",
  },
];

export default function About() {
  return (
    <section
      id="despre"
      data-testid="about-section"
      className="py-20 lg:py-28 bg-slate-950"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="text-amber-600 font-semibold text-sm uppercase tracking-widest">
                Despre noi
              </span>
              <h2
                data-testid="about-title"
                className="mt-3 text-3xl lg:text-4xl font-bold text-white"
              >
                Partenerul tău de încredere pentru fiecare călătorie.
              </h2>
              <p className="mt-5 text-slate-300 leading-relaxed">
                La <strong className="text-white">GlobalTransport</strong>{" "}
                suntem dedicați să oferim servicii de transport persoane la cel
                mai înalt nivel de calitate, confort și siguranță. Fie că ai
                nevoie de un transfer aeroport, un transport pentru evenimente
                sau o excursie de grup — suntem aici pentru tine.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-5">
              {features.map((f, i) => (
                <div
                  key={f.title}
                  data-testid={`about-feature-${i}`}
                  className={`group relative bg-slate-900 border border-slate-800 rounded-2xl p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:border-amber-300 ${
                    i === 0 ? "sm:row-span-2" : ""
                  }`}
                >
                  <div className="w-12 h-12 rounded-xl bg-slate-900 text-amber-400 flex items-center justify-center group-hover:bg-amber-500 group-hover:text-slate-950 transition-colors">
                    <f.icon className="w-6 h-6" strokeWidth={2.2} />
                  </div>
                  <h3 className="mt-5 text-xl font-semibold text-white">
                    {f.title}
                  </h3>
                  <p className="mt-2 text-slate-300 text-sm leading-relaxed">
                    {f.text}
                  </p>
                  {i === 0 && (
                    <div className="absolute bottom-7 left-7 right-7 mt-8 pt-6 border-t border-slate-800 hidden sm:block">
                      <p className="text-xs text-slate-400">
                        Vehicule verificate tehnic, asigurare RCA + CASCO,
                        respectarea integrală a normelor de transport
                        persoane.
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="mt-6 grid grid-cols-3 gap-4">
              {[
                { v: "10+", l: "Ani experiență" },
                { v: "5.000+", l: "Călători mulțumiți" },
                { v: "4.9★", l: "Rating Google" },
              ].map((s, i) => (
                <div
                  key={i}
                  data-testid={`about-stat-${i}`}
                  className="bg-slate-900 text-white rounded-2xl p-5 text-center"
                >
                  <div className="text-2xl lg:text-3xl font-bold text-amber-400">
                    {s.v}
                  </div>
                  <div className="text-xs uppercase tracking-wider text-slate-300 mt-1">
                    {s.l}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
